import { useEffect } from 'react';

/**
 * Browser zoom (Ctrl+−/+ эсвэл Ctrl+mouse wheel)-ийг автомат мэдрээд
 * `window.resize` event-ыг dispatch хийнэ. Дараах нөхцлүүдэд хариулна:
 *
 *  - `window.matchMedia('(resolution: Xdppx)')` change — devicePixelRatio
 *    өөрчлөгдөх бүрд firr болно (zoom step бүр).
 *  - `visualViewport.resize` — Safari iPad/iOS-ийн pinch zoom-ыг барих.
 *
 * Handsontable нь дотроо `window.resize`-д listen хийдэг (`core.mjs`-ийн
 * `onWindowResize` callback) тул event-ыг dispatch хийхэд бүх HT instance
 * автомат `refreshDimensions()` дуудах ба `stretchH: 'all'` ажиллана.
 *
 * App-level (ShellLayout) бэлдмэл нэг удаа суулгана.
 */
export function useZoomResizeDispatch(): void {
  useEffect(() => {
    let mq: MediaQueryList | null = null;

    function dispatchResize() {
      window.dispatchEvent(new Event('resize'));
    }

    function setupMq() {
      if (mq) mq.removeEventListener('change', onZoom);
      const dpr = window.devicePixelRatio || 1;
      try {
        mq = window.matchMedia(`(resolution: ${dpr}dppx)`);
        mq.addEventListener('change', onZoom);
      } catch {
        mq = null;
      }
    }

    function onZoom() {
      // Зөв resolution-той media query нь зөвхөн нэг зүйлд match хийдэг тул
      // change болсон даруйд шинэ dppx-аар MQ-ийг дахин setup хийнэ.
      setupMq();
      dispatchResize();
    }

    function onVisualResize() {
      dispatchResize();
    }

    setupMq();
    const vv = window.visualViewport;
    vv?.addEventListener('resize', onVisualResize);

    return () => {
      mq?.removeEventListener('change', onZoom);
      vv?.removeEventListener('resize', onVisualResize);
    };
  }, []);
}
